"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/* eslint-disable react-hooks/rules-of-hooks */
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const OsmosysModalProvider_1 = require("./OsmosysModalProvider");
const context_1 = require("./context");
exports.OsmosysModal = originalProps => {
    const { osysName, osysSubType, children, body, centered = true } = originalProps, props = tslib_1.__rest(originalProps, ["osysName", "osysSubType", "children", "body", "centered"]);
    return (react_1.default.createElement(OsmosysModalProvider_1.OsmosysModalProvider, Object.assign({}, originalProps),
        react_1.default.createElement(reactstrap_1.Modal, Object.assign({ wrapClassName: "osmosys-modal-wrapper", modalClassName: "osmosys-modal-modal", "data-osmosys-comp": osysName, "data-osmosys-comp-base": "OsmosysModal", "data-osmosys-comp-subtype": osysSubType, centered: centered }, props), body ? react_1.default.createElement(exports.OsmosysModal.Body, null, children) : children)));
};
exports.OsmosysModal.Header = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return react_1.default.createElement(reactstrap_1.ModalHeader, Object.assign({}, props), children);
};
exports.OsmosysModal.SmartHeader = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    const { close } = context_1.useOsmosysModalUpdate();
    return react_1.default.createElement(reactstrap_1.ModalHeader, Object.assign({}, props), children(close));
};
exports.OsmosysModal.Body = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return react_1.default.createElement(reactstrap_1.ModalBody, Object.assign({}, props), children);
};
exports.OsmosysModal.Footer = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return react_1.default.createElement(reactstrap_1.ModalFooter, Object.assign({}, props), children);
};
//# sourceMappingURL=index.js.map